import { Button } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import useStyles from './ObservationsBrowserTop.styles'

type ObservationsBrowserTopProps = {
  children: React.ReactNode
  uploadComponent: React.ReactNode
  onUploadButtonClick?: () => void
  showUploadBox?: boolean
  uploadDisabled?: boolean
  leftContent?: React.ReactNode
}

export const ObservationsBrowserTop = ({
  children,
  uploadComponent,
  onUploadButtonClick,
  showUploadBox: externalShowUploadBox,
  uploadDisabled = false,
  leftContent,
}: ObservationsBrowserTopProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const [internalUploadBox, setInternalUploadBox] = useState(false)

  // Use external state if provided, otherwise use internal state
  const uploadBox =
    externalShowUploadBox !== undefined
      ? externalShowUploadBox
      : internalUploadBox

  const handleUploadButtonClick = () => {
    if (onUploadButtonClick) {
      // Custom click handler provided (e.g., show modal first)
      onUploadButtonClick()
    } else {
      // Default behavior: toggle upload area
      setInternalUploadBox(!internalUploadBox)
    }
  }

  return (
    <>
      <div className={classes.container}>
        <div>
          {uploadComponent ? (
            <Button
              data-testid="btnUploadId"
              onClick={handleUploadButtonClick}
              label={t('Upload new images')}
              buttonType="button"
              type="action"
              disabled={uploadDisabled}
            />
          ) : (
            leftContent
          )}
        </div>
        <div className={classes.actionsContainer}>
          <div id="divActionsId" className={classes.action}>
            {children}
          </div>
        </div>
      </div>

      {uploadBox && uploadComponent && <div>{uploadComponent}</div>}
    </>
  )
}
